module.exports = __webpack_public_path__ + "a41a5837452eee93168bca7ab72f2b6a.png";